import { ApiParameter, get, patch } from "@insite/client-framework/Services/ApiService";
import { RetailModeSettingsModel } from "@store/Types/RetailModeSettings";

const retailModeUrl = "/api/v1/retailpricing/settings";

export interface GetRetailModeSettingsApiParameter extends ApiParameter {
    force?: boolean;
}

export interface PatchRetailModeSettingsApiParameter extends ApiParameter {
    settings: RetailModeSettingsModel;
}

export function getRetailModeSettings(parameter: GetRetailModeSettingsApiParameter) {
    return get<RetailModeSettingsModel>(retailModeUrl, parameter);
}

export function patchRetailModeSettings(parameter: PatchRetailModeSettingsApiParameter) {
    return patch<RetailModeSettingsModel>(retailModeUrl, parameter.settings);
}
